import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Field } from 'react-final-form';
import type { FieldValidator } from 'final-form';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import { TextInput } from './TextInput/TextInput';
type NameField = {
  initialValue?: string;
  label: string;
  name: string;
  validate?: FieldValidator<string>;
};
type LocalizedNameFieldsProps = {
  nameField: NameField;
  surnameField: NameField;
};
const renderField = ({
  initialValue = '',
  label,
  name,
  validate
}: NameField) => <div className="w-full" key={name}>
		<Field name={name} validate={validate} initialValue={initialValue}>
			{fieldRenderProps => <TextInput {...fieldRenderProps} label={label} />}
		</Field>
	</div>;
export const LocalizedNameFields = t0 => {
  const $ = _c(4);
  const {
    nameField,
    surnameField
  } = t0;
  const isHuLanguage = useIsSelectedLanguage("hu");
  let t1;
  if ($[0] !== isHuLanguage || $[1] !== nameField || $[2] !== surnameField) {
    const fields = isHuLanguage ? [surnameField, nameField] : [nameField, surnameField];
    t1 = <div className="flex flex-col gap-4 md:flex-row">{fields.map(renderField)}</div>;
    $[0] = isHuLanguage;
    $[1] = nameField;
    $[2] = surnameField;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};